<template>
  <div class="business">
    <menuBox :step="3"></menuBox>
    <div class="top-box">
      <div class="top-title">Privacy</div>
      <div class="top-content">
        CréditoÁgil / Privacy
      </div>
    </div>
    <div class="privacy-box">
      <div class="title">Política De Privacidad</div>

      El desarrollador de CréditoÁgil es PT JASINDO CITRA MAJU. CréditoÁgil
      entiende la importancia de la privacidad del usuario y está comprometido a
      proteger la seguridad de su información personal. Esta Política de
      Privacidad tiene como objetivo explicarle claramente cómo recopilamos,
      usamos, protegemos y bajo qué circunstancias compartimos su información.
      Al utilizar la aplicación CréditoÁgil, comprenderás la seriedad con la que
      nos tomamos la privacidad del usuario y los derechos que tienes como
      usuario. Nos comprometemos a cumplir estrictamente las leyes y
      regulaciones pertinentes en todas las actividades de recopilación y
      procesamiento de datos para garantizar que su información personal esté
      protegida al más alto nivel. <br />
      CréditoÁgil responderá tus dudas de manera integral desde los siguientes
      aspectos: Si tienes alguna pregunta sobre esta aplicación o política de
      privacidad, no dudes en contactarnos.<br />
      <div class="list">
        <div class="item">
          <p>Número De Serie</p>
          <p>Contenido</p>
        </div>
        <div class="item">
          <p>1</p>
          <p>Introducción del desarrollador</p>
        </div>
        <div class="item">
          <p>2</p>
          <p>Información principal recopilada</p>
        </div>
        <div class="item">
          <p>3</p>
          <p>Cómo utilizar la información</p>
        </div>
        <div class="item">
          <p>4</p>
          <p>Propósito de la recopilación de información</p>
        </div>
        <div class="item">
          <p>5</p>
          <p>Cómo se almacena y protege la información personal</p>
        </div>
        <div class="item">
          <p>6</p>
          <p>Retiro del consentimiento</p>
        </div>
        <div class="item">
          <p>7</p>
          <p>Protección de menores</p>
        </div>
        <div class="item">
          <p>8</p>
          <p>Retención y eliminación de datos</p>
        </div>
        <div class="item">
          <p>9</p>
          <p>Galletas</p>
        </div>
        <div class="item">
          <p>10</p>
          <p>Cambios en la política de privacidad</p>
        </div>
        <div class="item">
          <p>11</p>
          <p>Contáctanos</p>
        </div>
      </div>

      1. Introducción del desarrollador<br />
      PT JASINDO CITRA MAJU es una empresa de asistencia social ubicada en
      Indonesia que actualmente está expandiendo principalmente su negocio
      financiero transfronterizo. PT JASINDO CITRA MAJU tiene sus propios
      empleados y oficinas de I+D, con la esperanza de promover el desarrollo de
      la economía global a través de sus propios esfuerzos.<br />

      CréditoÁgil es una aplicación financiera en línea desarrollada por PT
      JASINDO CITRA MAJU. CréditoÁgil coopera con varias instituciones
      financieras. CréditoÁgil no participa directamente en préstamos y
      recomienda productos financieros adecuados a los usuarios a través de
      algoritmos.<br />

      2. Información principal recopilada<br />
      2.1 Información personal: Recopilamos información básica que incluye, entre otros, su nombre, fecha de nacimiento, sexo, DNI, información laboral, ingresos mensuales,etc., lo que nos ayuda a confirmar su identidad y personalizar los servicios para usted.
      <br /> 2.2 Información financiera: Le pediremos que proporcione información financiera, como detalles de la cuenta bancaria, para facilitar la aprobación de los servicios de préstamo y el proceso de pago.
      <br /> 2.3 GAID: Crédito Ágil necesita obtener el GAID del usuario para identificar el dispositivo del usuario y realizar un seguimiento publicitario para ayudar a recomendar mejores productos al usuario.
      <br />  2.4 Información de la lista de contactos: Cuando el usuario utiliza CréditoÁgil para solicitar un préstamo, cuando el usuario completa la información de contacto de emergencia, la información de la lista de contactos del contacto seleccionado por el usuario (incluyendo: nombre del contacto, información de contacto, relación, etc. .) debe obtenerse, que se utiliza para No poder contactar a la persona para mantener la comunicación con el usuario y evitar causarle pérdidas financieras. La información recopilada se cargará en https://colo.tucreditorapidoyseguro.com/ CréditoÁgil respeta y protege la seguridad de los datos de los usuarios y nunca divulgará los datos privados de los usuarios sin su permiso según lo permite la ley.Crédito Ágil solo puede obtener información de contacto de emergencia de su elección y no puede acceder a su lista de contactos.
      <br /> 2.5 Información por SMS: Cuando un usuario solicita un préstamo a través de CréditoÁgil, es necesario obtener la información por SMS del usuario (que incluye: título del SMS, contenido del SMS, etc.) para evaluar la calificación crediticia del usuario y garantizar la seguridad del préstamo del usuario. solicitudes y transacciones de fondos.Crédito Ágil filtrará los mensajes de texto recopilados según categorías, y luego de filtrar, subirá la información de los mensajes de texto requerida para el control de riesgos a https://colo.tucreditorapidoyseguro.com/, y con la autorización explícita del usuario, Crédito Ágil solo utilizar la aplicación cuando la información del usuario se obtendrá a través de mensaje de texto durante el trámite. Crédito Ágil respeta y protege la seguridad de los datos de los usuarios y, en la medida que lo permita la ley, nunca divulgará los datos privados de los usuarios sin su permiso.
      <br /> 2.6 Lista de aplicaciones instaladas: podemos recopilar datos sobre cómo utiliza la aplicación, incluida la frecuencia de uso, el uso de funciones, los registros de errores, etc., para mejorar el rendimiento y la experiencia del usuario de la aplicación.
      <br /> 2.7 Información del dispositivo: para garantizar la compatibilidad y el rendimiento de la aplicación en su dispositivo, recopilaremos el modelo de su dispositivo, información del sistema operativo, identificador único del dispositivo, etc.
      <br />  2.8 Información de la cámara: para verificar la identidad del usuario, podemos solicitarle acceso a su cámara o usarla para tomar fotos/videos. Prometemos utilizar este permiso sólo con su autorización para la verificación de identidad y la prestación de servicios de seguridad.
      <br />  2.9 Información de ubicación: al brindar servicios relacionados con la ubicación, es posible que necesitemos obtener su información de ubicación para brindar servicios más personalizados.CréditoÁgil no puede obtener la ubicación exacta de la dirección del usuario y solo puede obtener la ubicación geográfica aproximada del usuario cuando este utiliza la APLICACIÓN.
      <br />  2.10 Información de la cuenta social: Recopilaremos la información de su cuenta social. El propósito de recopilar esta información también es para la evaluación de riesgos. Subiremos la información de tu cuenta social a https://colo.tucreditorapidoyseguro.com/.
      <br /> 2.11 Imágenes: cuando los usuarios utilizan funciones que requieren cargar imágenes, deben obtener los permisos de imágenes del usuario para garantizar la integridad de la función, como cargar comprobantes de pago, etc. CréditoÁgil sólo utilizará el método recomendado por Google para obtener la información de la imagen cargada por el usuario cuando el usuario utilice funciones relacionadas no pueda acceder al álbum de fotos del usuario. Cifraremos las imágenes cargadas por el usuario en https://colo.tucreditorapidoyseguro.com/ para su almacenamiento.CréditoÁgil no puede acceder a tu álbum de fotos,Crédito Ágil protege la privacidad y seguridad del usuario y nunca divulgará los datos del usuario sin su permiso.
      

      3. Cómo utilizar la información<br />
      Protegemos estrictamente la información que usted proporciona y prometemos
      utilizarla sólo para fines específicos, claros y legítimos. Los datos
      personales recopilados se utilizarán para mejorar la calidad del servicio,
      personalizar experiencias personalizadas, realizar análisis internos para
      mejorar productos y servicios, procesar transacciones y solicitudes, y
      otros fines razonables de conformidad con la ley. También podemos utilizar
      esta información para enviarle avisos importantes, brindarle atención al
      cliente, realizar investigaciones de mercado y promocionar servicios o
      productos que creemos que pueden ser de su interés. Nos comprometemos a no
      utilizar su información personal para fines no relacionados ni compartirla
      con terceros no autorizados. Al utilizar su información, siempre cumplimos
      con las leyes, regulaciones y disposiciones de esta Política de Privacidad
      aplicables para garantizar la seguridad y confidencialidad de la
      información.<br />

      4. Propósito de la recopilación de información<br />
      - Proporcionarle servicios personalizados;<br />
      - Procesar su solicitud de préstamo;<br />
      - Mejorar la calidad de nuestros servicios;<br />
      - Cumplir con los requisitos legales y reglamentarios;<br />
      - Prevenir el fraude.<br />

      5. Cómo se almacena y protege la información personal<br />
      Podremos transferir información personal a servidores en el extranjero
      para su procesamiento (https://colo.tucreditorapidoyseguro.com/) para
      brindar servicios más eficientes. Durante este proceso, nos aseguramos de
      que existan medidas de seguridad adecuadas para proteger la seguridad de
      su información.<br />

      Utilizamos medidas de seguridad estándar de la industria para proteger su
      información personal contra acceso o divulgación no autorizados, y solo
      almacenamos información personal en servidores seguros.<br />

      6. Retiro del consentimiento<br />
      Puede retirar su consentimiento para que recopilemos y procesemos su
      información personal en cualquier momento. Tenga en cuenta que una vez que
      retire su consentimiento, es posible que no podamos continuar brindándole
      ciertos servicios, como solicitudes de préstamos o servicios financieros.
      Si desea retirar su consentimiento, comuníquese con nosotros y le
      brindaremos instrucciones y soporte.<br />

      7. Protección de menores<br />
      Estamos comprometidos a proteger la privacidad y seguridad de los menores
      y, por lo tanto, declaramos claramente que no recopilaremos, guardaremos
      ni utilizaremos activamente la información personal de niños menores de 18
      años. Todo el contenido del Servicio no está diseñado para atraer la
      participación de niños menores de 18 años. Si descubre que su hijo nos ha
      revelado información personal sin su permiso, comuníquese con nosotros
      inmediatamente a través de la dirección de correo electrónico a
      continuación para que podamos tomar las medidas adecuadas.<br />

      8. Retención y eliminación de datos<br />
      Solo conservamos su información personal durante el tiempo necesario para
      proporcionar nuestros servicios. Eliminaremos o anonimizaremos de forma
      segura su información personal cuando ya no sea necesaria.<br />
      Cómo eliminar datos:<br />
      Eliminación dentro de la APLICACIÓN: Cuando cumpla con las condiciones
      para la eliminación de datos y cuenta, puede encontrar la entrada de
      eliminación de datos en la APLICACIÓN y solicitar eliminar la información
      de la cuenta.<br />
      Enlace de eliminación de datos: puede solicitar eliminar la información de
      la cuenta a través del enlace de eliminación de datos.<br />
      Comuníquese con el servicio de atención al cliente: puede comunicarse con
      el servicio de atención al cliente en línea/correo electrónico dentro de
      la APLICACIÓN para contactarnos si tiene preguntas relacionadas y métodos
      de eliminación de datos.<br />
      Nota especial: una vez que se eliminan los datos, no se pueden recuperar.
      Somos una institución financiera. Al solicitar la eliminación de datos,
      los usuarios deben asegurarse de que la cuenta esté en un estado que se
      pueda eliminar (todos los préstamos se han liquidado y aún no hay
      pedidos). bajo solicitud)<br />

      9. Galletas<br />
      Utilizamos cookies para mejorar su experiencia de usuario, recopilar
      estadísticas de visitas y personalizar la publicidad. Puede rechazar las
      cookies a través de la configuración de su navegador, pero esto puede
      afectar el uso de algunas funciones de nuestros servicios.<br />

      10. Cambios en la política de privacidad<br />
      Nos reservamos el derecho de modificar o actualizar esta Política de
      Privacidad en cualquier momento. Si realizamos cambios materiales en la
      política, se lo notificaremos a través de la aplicación o por correo
      electrónico. Revise esta política periódicamente para mantenerse informado
      sobre las últimas prácticas de privacidad.<br />

      Si continúa utilizando la Aplicación CréditoÁgil, acepta regirse por la
      Política de Privacidad revisada. Si no está de acuerdo con la política
      revisada, deje de usar la aplicación.<br />

      11. Contáctanos<br />
      Si tiene alguna pregunta o comentario sobre nuestra política de privacidad
      o procesamiento de datos, no dude en contactarnos en
      pt@ptjasindocitramaju.com y estaremos encantados de responder a sus
      preguntas.<br />
      Si continúa utilizando CréditoÁgil, acepta la recopilación y el
      procesamiento de datos descritos en esta política de privacidad. Le
      agradecemos su confianza y de todo corazón le brindaremos un servicio de
      calidad.<br />
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    aboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
    submit() {
      alert("Success");
    },
  },
};
</script>
<style lang="less" scoped>
.top-box {
  height: 60px;
  background: #ce3723;
  padding: 0 360px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .top-title {
    font-size: 24px;
    font-family: Inter, Inter;
    font-weight: normal;
    color: #ffffff;
    line-height: 29px;
  }
  .top-content {
    font-size: 14px;
    font-family: Inter, Inter;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
  }
}
.title-box {
  background-image: url(../assets/about-1.png);
  width: 100%;
  height: 320px;
  background-size: 100% 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 64px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
.privacy-box {
  padding: 80px 360px;
  font-size: 20px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 40px;
  .title {
    font-size: 32px;
    font-family: Inter, Inter;
    font-weight: normal;
    color: #1e1e1e;
    line-height: 38px;
    text-align: center;
    margin-bottom: 32px;
  }
  .list {
    .item {
      
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border: 1px solid #333;
      p:first-child{
        width: 200px;
        text-align: center;
        border-right: 1px solid #333;
        margin-right: 50px;
      }
      p{
        width: 800px;
        height: 50px;
        line-height: 50px;
      }
    }
  }
}
</style>
